// src/components/CategoryHero.js
import React, { useContext, useEffect, useState } from "react";
import { LanguageContext } from "../context/LanguageContext";
import { useNavigate } from "react-router-dom";
import { getHomepageCategoryHero } from "../services/homepage.api";

function CategoryHero() {
  const { lang } = useContext(LanguageContext);
  const navigate = useNavigate();
  const [hero, setHero] = useState(null);

  useEffect(() => {
    getHomepageCategoryHero().then(setHero).catch(() => {});
  }, []);

  if (!hero) return null;

  return (
    <button
      onClick={() => {
  const key = hero.link_target;

  if (["new-in", "sale", "bestsellers"].includes(key)) {
    navigate(`/products/${key}`);
  } else {
    navigate(`/products/category/${key}`);
  }
}}

      className="
        w-full mt-2 mb-1 relative overflow-hidden group
        card-3d
        animate-fadeIn
      "
    >
      {/* IMAGE */}
      <img
        src={hero.image_url}
        loading="lazy"
        decoding="async"
        alt={lang === "EN" ? hero.title_en : hero.title_ar}
        className="
          w-full h-60 md:h-[480px] object-cover
          transition-transform duration-[1200ms]
          group-hover:scale-110
          parallax-image
        "
      />

      {/* DARK TACTICAL OVERLAY */}
      <div className="absolute inset-0 bg-black/55"></div>

      {/* HUD GRID */}
      <div className="absolute inset-0 hud-grid opacity-25 pointer-events-none" />

      {/* SHINE SWEEP */}
      <div className="absolute inset-0 shine-effect opacity-30 pointer-events-none" />

      {/* CENTER CONTENT */}
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
        <p className="text-xl md:text-4xl font-semibold tracking-wide text-white drop-shadow-md">
          {lang === "EN" ? hero.title_en : hero.title_ar}
        </p>

        <p className="mt-3 text-sm md:text-lg text-white/80 max-w-xl">
          {lang === "EN" ? hero.subtitle_en : hero.subtitle_ar}
        </p>

        <span className="mt-5 underline text-sm md:text-base text-[#2E5A2A] font-semibold tracking-wide">
          {lang === "EN" ? "SHOP NOW" : "تسوقي الآن"}
        </span>
      </div>
    </button>
  );
}

export default CategoryHero;
